import React from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_khaugali/layout/core'
import { AddExpenseMaster } from '../../pages/expense_master_master/add_expense/AddExpenseMaster'
import ExpenseMasterList from '../../pages/expense_master_master/expense_list/ExpenseMasterList'
const productBreadCrumbs: Array<PageLink> = [
  {
    title: 'Expense Master',
    path: '/expense/list',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ExpenseMasterPage: React.FC = () => {
  return (
    <>
      <Switch>
        <Route path='/expense/list'>
          {/* <PageTitle breadcrumbs={productBreadCrumbs}>Expense Master List</PageTitle> */}
          <PageTitle>Expense Master List</PageTitle>
          <ExpenseMasterList />
        </Route>
        <Route path='/expense/create'>
          {/* <PageTitle breadcrumbs={productBreadCrumbs}>Add Master Expense</PageTitle> */}
          <PageTitle>Add Master Expense</PageTitle>
          <AddExpenseMaster />
        </Route>
        {/* <Route path='/expense/edit/:expenseid'>
          <PageTitle breadcrumbs={productBreadCrumbs}>Edit Expense</PageTitle>
          <EditExpenseType />
        </Route> */}
        <Redirect from='/expense' exact={true} to='/expense/list' />
        <Redirect to='/expense/list' />
      </Switch>
    </>
  )
}

export default ExpenseMasterPage
